<mat-stepper #stepper class="h-100 navigation-disabled" labelPosition="bottom" [linear]="false" [selectedIndex]="stepIndex">
  <mat-step state="company" label="Select Company" [completed]="!!customerCompany">
    <ng-select-company-container></ng-select-company-container>
  </mat-step>
  <mat-step state="provider" label="Select 3PL Provider" [completed]="!!providerCompany">
    <ng-select-company-provider-container></ng-select-company-provider-container>
  </mat-step>
  <mat-step state="authorization" label="Select Authorization Level" [completed]="!!authStatus">
    <ng-third-party-authorization-container></ng-third-party-authorization-container>
  </mat-step>
  <mat-step state="preview" label="Preview Contract">
    <ng-third-party-preview-container></ng-third-party-preview-container>
  </mat-step>
  <mat-step state="contract" label="Done" *ngIf="isDoneEnabled">
    <ng-third-party-done-container></ng-third-party-done-container>
  </mat-step>

  <ng-template matStepperIcon="edit">
    <mat-icon *ngIf="stepper.selected?.state === 'company'" matSuffix fontSet="fas" fontIcon="fa-building">
    </mat-icon>
    <mat-icon *ngIf="stepper.selected?.state === 'provider'" matSuffix fontSet="fas" fontIcon="fa-address-book">
    </mat-icon>
    <mat-icon *ngIf="stepper.selected?.state === 'authorization'" matSuffix fontSet="fas" fontIcon="fa-users">
    </mat-icon>
    <mat-icon *ngIf="stepper.selected?.state === 'preview'" matSuffix fontSet="fas" fontIcon="fa-file-signature">
    </mat-icon>
    <mat-icon *ngIf="stepper.selected?.state === 'contract'" matSuffix fontSet="fas" fontIcon="fa-check-circle">
    </mat-icon>
  </ng-template>

  <ng-template matStepperIcon="done">
    <mat-icon matSuffix fontSet="fas" fontIcon="fa-check">
    </mat-icon>
  </ng-template>

  <ng-template matStepperIcon="company">
    <mat-icon matSuffix fontSet="fas" fontIcon="fa-building"></mat-icon>
  </ng-template>
  <ng-template matStepperIcon="provider">
    <mat-icon matSuffix fontSet="fas" fontIcon="fa-address-book"></mat-icon>
  </ng-template>
  <ng-template matStepperIcon="authorization">
    <mat-icon matSuffix fontSet="fas" fontIcon="fa-users"></mat-icon>
  </ng-template>
  <ng-template matStepperIcon="preview">
    <mat-icon matSuffix fontSet="fas" fontIcon="fa-file-signature"></mat-icon>
  </ng-template>

  <ng-template matStepperIcon="contract">
    <mat-icon matSuffix fontSet="fas" fontIcon="fa-check-circle"></mat-icon>
  </ng-template>
</mat-stepper>
